import { getAuthTokenRaw } from "./tokenHeaders";

export function getMediaBaseUrl() {
  const hostname = window.location.hostname;
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

  return isLocal ? "http://localhost:3004" : "";
}

export function getServerMediaUrl(relativePath, cacheKey = "") {
  if (!relativePath) return null;

  const normalized = String(relativePath).replace(/^\/+/, "");
  const base = `${getMediaBaseUrl()}/${normalized}`;
  const params = new URLSearchParams();

  const token = getAuthTokenRaw();
  if (token) {
    params.set("token", token);
  }

  if (cacheKey !== "" && cacheKey != null) {
    params.set("v", String(cacheKey));
  }

  const query = params.toString();
  return query ? `${base}?${query}` : base;
}
